/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Tagindex_Description1Inputs */

const en_seo_tagindex_description1 = /** @type {(inputs: Seo_Tagindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse AI tools by tag and find AI tools for specific use cases.`)
};

const zh_seo_tagindex_description1 = /** @type {(inputs: Seo_Tagindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按标签浏览 AI 工具，找到特定场景的 AI 工具。`)
};

/**
* | output |
* | --- |
* | "Browse AI tools by tag and find AI tools for specific use cases." |
*
* @param {Seo_Tagindex_Description1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const seo_tagindex_description1 = /** @type {((inputs?: Seo_Tagindex_Description1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Tagindex_Description1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seo_tagindex_description1(inputs)
	return zh_seo_tagindex_description1(inputs)
});
export { seo_tagindex_description1 as "seo.tagIndex.description" }